import Glide from '@glidejs/glide'; 


jQuery(document).ready(function ()
{
    // new Glide('.glide', {
    //     type: 'carousel',
    //     startAt: 0,
    //     perView: 3
    // }).mount()
})
